export function loadUpscope() {
  if (import.meta.env.MODE !== 'production') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (function (w: any, u: unknown, d: Document) {
    const i: any = function () {
      // eslint-disable-next-line prefer-rest-params
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args: IArguments) {
      i.q.push(args);
    };
    const l = function () {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://code.upscope.io/Hja7NQqU7o.js';
      const x = d.getElementsByTagName('script')[0];
      if (!x?.parentNode) {
        console.error('Upscope failed to insert script: missing parent node');
        return;
      }
      x.parentNode.insertBefore(s, x);
    };
    if (typeof u !== 'function') {
      w.Upscope = i;
      l();
    }
  })(window, window.Upscope, document);

  window.Upscope('init');
}
